import React from "react";
import { Dispatch } from "react";

import Modal, { IModal } from "../../../../Components/Helpers/Modal";
import { EnhancedCustomer } from "../../../../Models/Customer";
import { Lead } from "../../../../Models/Lead";
import ContactOverrideForm from "./ContactOverrideForm";

export interface IContactOverrideModalProps
  extends Required<Pick<IModal, "handleClose" | "handleConfirm" | "open">>,
    Omit<IModal, "title" | "handleClose" | "handleConfirm" | "open"> {
  customer: EnhancedCustomer;
  contact: Lead;
  setOverrideContact: Dispatch<boolean>;
}

const ContactOverrideModal: React.FC<IContactOverrideModalProps> = ({
  customer,
  contact,
  setOverrideContact,
  ...rest
}) => {
  return (
    <Modal title="Contact Info Override" {...rest}>
      <ContactOverrideForm customer={customer} contact={contact} setOverrideContact={setOverrideContact} />
    </Modal>
  );
};

export default ContactOverrideModal;
